/** Apply a symbol's chart display overrides onto the global rule settings (pure). */
import { clampCmeSpikeSettings, type CmeSpikeSettings } from './cmeVolumeSpikes';
import type { ChartDisplaySettings } from '../store/symbolChartDisplayStore';

export function effectiveCmeSpikeSettings(global: CmeSpikeSettings, display: ChartDisplaySettings | null | undefined): CmeSpikeSettings {
  return display?.volumePaneCmeSpike ? clampCmeSpikeSettings({ ...global, ...display.volumePaneCmeSpike }) : global;
}

export function effectiveWickRule(
  global: { minWickPct: number; minWickAtr: number },
  display: ChartDisplaySettings | null | undefined,
): { minWickPct: number; minWickAtr: number } {
  const w = display?.wickRejection;
  return { minWickPct: w?.minWickPct ?? global.minWickPct, minWickAtr: w?.minWickAtr ?? global.minWickAtr };
}
